import { mapState } from 'vuex';
import resource from '../../../share/util/resourceMap';
import util from '../../../share/util/utils';
// import cstmPaging from '../../../share/components/vue/Pagination';
import cstmTable from '../../../share/components/vue/PaginationTable';
import config from '../../../share/config';
import { getObdSaveOrderTable } from '../../../util/obd/ffd';
import constants from '../../../common/nodejs/constants';
import { convertKeyForPidToDid } from '../../../util/obd/pid';
import { getMeasuredDataName, getCsvFileName } from '../../../util/fileExport';
import diagnoseResource from '../../../share/util/diagnose';

const FFD_I18N_MAP = require('../../../data/ffdi18nKeyMap.json');

const DTC_STATUS_TENTATIVE = 'message.i_status_vehicle_dtc_status_tentative';
const DTC_STATUS_TENTATIVE_LATEST = 'message.e_status_vehicle_dtc_status_tentative_latest';

export default {
  name: 'ffdModal',
  data() {
    return {
      // ffdListBuff: [],
      ffdGroupOptions: [],
      selectedFFDGroup: null,
      ffdDetailTableColumns: [],
      ffdTableItems: [],
      maxItemsPerPage: Number(process.env.VUE_APP_PROJECT_PAGE_DISPLAY_COUNT),
      // totalFFDItemLength: 0,
      // currentPage: 0,
      currentFFDContents: {}
    };
  },

  props: {
    ffdTableProp: { type: Array, default: [], required: false },
    systemProp: { type: Object, default: {}, required: false },
    // モーダルにシステムと説明を表示する為のProps。未設定の場合は非表示となる
    ffdSystem: { type: String, default: '', required: false },
    ffdDescription: { type: String, default: '', required: false },
    dataPlayback: { type: Boolean, default: false, required: false },
    isObd: { type: Boolean, default: false, required: false },
    // (WS)REQ-05固有の処理か
    isReq05: { type: Boolean, default: false, required: false },
    storedDataNumberProp: { type: String, default: '-', required: false },
    // ファイルエクスポート
    dataName: { type: String, default: '', required: false },
    destinationAPI: { type: String, default: '', required: false },
    projectId: { type: String, default: '', required: false },
    measureId: { type: String, default: '', required: false },
  },

  components: {
    // 'cstm-paging-modal': cstmPaging,
    'cstm-table-modal': cstmTable,
  },

  methods: {

    /**
     * プロトコルとDTCステータスから、FFD詳細画面で初期選択するFFD種別を取得する
     * ステータスは対応した文言キーに変換されているので、文言キーと比較してFFD種別の初期選択を行う
     * - FHI_CAN: ステータスが「仮」の場合は仮FFD、それ以外は確定FFD
     * - Phase5: ステータスが「仮」「仮/最新結果」の場合は仮FFD、それ以外は確定FFD
     * - Phase4/Phase6 など: 種別による切り替えを行わない
     * @returns {string|null} デフォルト選択対象のFFD種別。判定不要な場合は `null`
     */
    getDefaultFFDTypeByProtocolAndStatus: function () {
      // FFDレスポンスのprotocolとシステム情報のstatusで判定する
      const protocol = this.ffdTableProp?.[0]?.protocol;
      const status = this.systemProp?.status;

      switch (protocol) {
        case config.PROTOCOL_FHI_CAN:
          // FHI_CAN: 「仮」のときのみ仮FFDを初期選択する
          return status === DTC_STATUS_TENTATIVE ? config.FFD_TYPE_TENTATIVE : config.FFD_TYPE_CONFIRM;
        case config.PROTOCOL_PHASE5:
          // Phase5: 「仮」「仮/最新結果」は仮FFD、それ以外は確定FFDを初期選択する
          return [DTC_STATUS_TENTATIVE, DTC_STATUS_TENTATIVE_LATEST].includes(status)
            ? config.FFD_TYPE_TENTATIVE
            : config.FFD_TYPE_CONFIRM;
        default:
          // Phase4/Phase6 などは保存順優先のため、種別によるデフォルト制御は行わない
          return null;
      }
    },

    /**
     * FFDプルダウン候補から、仕様に従ったデフォルト選択キーを取得する
     * @param {Array<{key:number, value:{ffd_type:string}}>} ffdResultItem FFD選択候補一覧
     * @returns {number|null} デフォルト選択するキー
     */
    getDefaultFFDGroupKey: function (ffdResultItem) {
      if (!Array.isArray(ffdResultItem) || ffdResultItem.length < 1) {
        return null;
      }

      // 仕様上のデフォルトFFD種別を取得する
      const defaultFFDType = this.getDefaultFFDTypeByProtocolAndStatus();
      if (!defaultFFDType || this.isReq05) {
        // 種別判定が不要なプロトコル(Phase4,Phase6)/REQ-05では、ソート後の先頭をそのまま初期選択する
        return ffdResultItem[0].key;
      }

      // 判定したFFD種別に一致する候補を優先して選択する
      const defaultFFDGroup = ffdResultItem.find(item => item.value.ffd_type === defaultFFDType);
      // 対象種別が存在しない場合は、従来どおり先頭候補にフォールバックする
      return defaultFFDGroup ? defaultFFDGroup.key : ffdResultItem[0].key;
    },

    // FFD グループの選択オプションを生成
    makeFFDGroupOptions: function () {
      if (!this.ffdTableProp || this.ffdTableProp.length < 1) return;
      // ffd_save_order で重複排除
      const latest = this.$t('individual.label_table_history_latest');
      const confirmed = this.$t('message.status_vehicle_ffd_order_confirmed');
      const temporary = this.$t('message.status_vehicle_ffd_order_temporary');
      const flt = [];
      const opts = [];
      for (const p of this.ffdTableProp) {
        if (!flt.some(e => e.ffd_save_order === p.ffd_save_order && e.ffd_type === p.ffd_type)) {
          // 重複チェック用の配列データ
          flt.push({ ffd_save_order: p.ffd_save_order, ffd_type: p.ffd_type });
          // プルダウンのデータ生成
          const optData = { key: 0, value: { ffd_save_order: p.ffd_save_order, label: null, ffd_type: p.ffd_type } };
          if (this.isReq05) {
            // REQ-05は「最新」固定表示
            optData.key = 4;
            optData.value.label = latest;
          }
          // REQ-05以外は、FFD種別に応じて「確定」⇒「仮」の順番で表示する
          // 同一の種別が複数ある場合は保存順での表示となるため、ffd_save_order も考慮して key を設定する
          else if (p.ffd_type === config.FFD_TYPE_CONFIRM && p.ffd_save_order === 0) {
            optData.key = 0;
            optData.value.label = confirmed;
          }
          else if (p.ffd_type === config.FFD_TYPE_CONFIRM && p.ffd_save_order === 1) {
            optData.key = 1;
            optData.value.label = confirmed;
          }
          else if (p.ffd_type === config.FFD_TYPE_TENTATIVE && p.ffd_save_order === 0) {
            optData.key = 2;
            optData.value.label = temporary;
          }
          else if (p.ffd_type === config.FFD_TYPE_TENTATIVE && p.ffd_save_order === 1) {
            optData.key = 3;
            optData.value.label = temporary;
          }
          else {
            // 上記条件に合致しない場合は「確定」で表示
            optData.value.label = confirmed;
          }
          opts.push(optData);
        }
      }
      // プルダウンは key の昇順でソートし、確定→仮 の順で表示する(REQ-05の場合は最新のみ表示)
      // プルダウンのラベルには保存順の情報を表示せず、「確定」か「仮」のみを表示する
      const ffdResultItem = util.sortItems(opts, 'key', config.ASC);
      this.ffdGroupOptions = ffdResultItem;
      // プロトコルとDTCステータスに応じて、仕様通りのFFD種別を初期表示する
      this.selectedFFDGroup = this.getDefaultFFDGroupKey(ffdResultItem);
    },

    // OBD FFD グループの選択オプションを生成
    makeObdFFDGroupOptions: function () {
      if (!this.ffdTableProp || this.ffdTableProp.length < 1) return;
      // ffd_save_order で重複排除
      const latest = this.$t('individual.label_table_history_latest');
      const oldest = this.$t('fixed_resource.n_status_vehicle_dtc_status_oldest');
      const flt = [];
      const opts = [];
      for (const p of this.ffdTableProp) {
        if (!flt.some(e => e.ffd_save_order === p.ffd_save_order)) {
          // 重複チェック用の配列データ
          flt.push({ ffd_save_order: p.ffd_save_order });
          // プルダウンのデータ生成
          const optData = { key: 0, value: { ffd_save_order: p.ffd_save_order, label: null } };
          if (p.ffd_save_order === 0 && constants.UPPER_LAYER_PROTOCOL_SAEJ1979 === p.protocol) {
            optData.value.label = latest;
          } else if (p.ffd_save_order === 0 && constants.UPPER_LAYER_PROTOCOL_OBD_ON_UDS) {
            optData.key = 1;
            optData.value.label = oldest;
          } else {
            // 上記条件に合致しない場合は「最新(確定)で表示」
            optData.value.label = latest;
          }
          opts.push(optData);
        }

        // JSONファイルの形式に合わせて、PIDをDIDに変換
        p.id = convertKeyForPidToDid(p.id);

        for (const q of p.ffd_data) {
          q.digital_expression = convertKeyForPidToDid(q.digital_expression);
          if (q.term_expression !== null) {
            q.term_expression = convertKeyForPidToDid(q.term_expression);
          }
        }
      }
      // プルダウンの表示順のソート
      const ffdResultItem = util.sortItems(opts, 'key', config.ASC);
      this.ffdGroupOptions = ffdResultItem;
      // プルダウン初期表示
      this.selectedFFDGroup = ffdResultItem[0].key;
    },

    // FFD 一覧の生成
    updateFFDTable: function (group) {
      const findIndex = this.ffdGroupOptions.findIndex(e => e.key === group);
      if (findIndex === -1) return;

      const ffdGroup = this.ffdGroupOptions[findIndex];
      // ffd_save_order が一致しているレコードを抽出 (Req05は固定のため抽出不要)
      const flt = this.isReq05 ? this.ffdTableProp : this.ffdTableProp.filter(p => p.ffd_save_order === ffdGroup.value.ffd_save_order && p.ffd_type === ffdGroup.value.ffd_type);
      const instance = this;
      const pre = [
        { name: 'item', label: 'message.header_vehice_ffd_item', useResource: true },
        { name: 'unit', label: 'message.header_vehice_ffd_unit', useResource: true },
      ];
      const ffd = resource.getSaveOrderTable(flt, this.systemProp.systemID, FFD_I18N_MAP, instance);
      // 重複なしで column を作成
      const cols = Array.from(new Set(ffd.headers)).sort((a, b) => a - b);
      const detected = cols.map(e => (e ? { name: e, label: resource.changeDidHeaders(this, e), useHtmlBind: true } : { name: '0', label: 'message.header_vehice_ffd_detected' }));
      this.ffdDetailTableColumns = pre.concat(detected);
      // テーブルの内容を作成
      this.currentFFDContents = ffd;
      this.ffdTableItems = ffd.items;
      // this.ffdListBuff = ffd.items;
      // this.totalFFDItemLength = this.ffdListBuff.length;
      // this.currentPage = 1;
      // this.ffdTableItems = this.filterPerPageSize();
    },

    // FFD 一覧の生成
    updateObdFFDTable: function (group) {
      const findIndex = this.ffdGroupOptions.findIndex(e => e.key === group);
      if (findIndex === -1) return;

      const ffdGroup = this.ffdGroupOptions[findIndex];
      // ffd_save_order が一致しているレコードを抽出
      const flt = this.ffdTableProp.filter(p => p.ffd_save_order === ffdGroup.value.ffd_save_order);
      const instance = this;
      this.ffdDetailTableColumns = [
        { name: 'item', label: 'message.header_vehice_ffd_item', useResource: true },
        { name: 'unit', label: 'message.header_vehice_ffd_unit', useResource: true },
        { name: '0', label: 'message.header_vehice_ffd_detected' },
      ];
      const ffd = getObdSaveOrderTable(flt, instance);
      const filteredFfd = ffd.items.filter(e => this.$te(e.item));
      // テーブルの内容を作成
      ffd.items = filteredFfd;
      this.currentFFDContents = ffd;
      this.ffdTableItems = ffd.items;
    },

    // FFD ソート初期化
    initializeFFDSort: function () {
      // this.ffdTableItems = this.filterPerPageSize();
      this.ffdTableItems = this.ffdTableItems.concat();
    },

    changeFFDMeasurement: function (group) {
      // FFD 一覧の生成を判別する
      if (this.isObd) {
        this.updateObdFFDTable(group);
      } else {
        this.updateFFDTable(group);
      }
    },

    /**
     * ファイルエクスポートボタン処理
     */
    async csvExport() {
      let header = '';
      let body = '';
      let fileName = '';

      try {
        this.$emit('updateLoading', true);

        let endPoint = '';
        let measuredDataName = '';

        if (!this.isTestMode && this.projectId !== '' && this.measureId !== '') {
          // プロジェクトIDおよび計測データIDが存在する場合、計測データ取得APIを指定
          endPoint = '/projects/' + this.projectId + '/' + this.measureId;
          // 計測データ名を取得
          measuredDataName = await getMeasuredDataName(this, this.destinationAPI, endPoint, this.operationScreen);
        }
        fileName = getCsvFileName(
          this.$t('message.header_vehicle_dtc_table_ffd'),
          this.dataName !== '' ? this.dataName : measuredDataName,
          this.vin
        );

        const nameData = this.ffdDetailTableColumns.map(item => item['name']);
        const headerLabelList = this.ffdDetailTableColumns.map(key => key);
        const vinHeader = `"${this.$t('message.label_measured_data_search_vin')}",${util.escapeForCsv(this.vin)}\n`;
        const dtcCodeLabel = this.$t('individual.individual_diagnosis_function_diag_code') + this.$t('message.header_vehicle_dtc_table_code');
        const dtcCodeHeader = `"${dtcCodeLabel}",${util.escapeForCsv(this.systemProp.dtc)}\n`;

        header = headerLabelList.map(head => {
          let formattedHeader = '';
          if (typeof (head['name']) === 'number') {
            formattedHeader = head['label'];
          } else {
            formattedHeader = this.$t(head['label']) ? this.$t(head['label']) : head;
          }
          return `"${formattedHeader}"`;
        }).join(",") + "\n";
        header = vinHeader + dtcCodeHeader + header;

        body = this.ffdTableItems.map((d) => {
          return nameData.map((key) => {
            let retVal = d[key];
            switch (key) {
              case 'item':
              case 'unit':
                retVal = this.$t(d[key]);
                break;
              default:
                // data_type: RxSWIN 改行対応
                if (retVal.includes('<br>')) retVal = d[key].replace(/<br\s*\/?>/gi, '\r\n');
                break;
            }
            // 最終的な値が空の場合、ダブルクォーテーションを表示させないように、エスケープ処理を行わないようにする
            return retVal || (typeof retVal === 'number') ? util.escapeForCsv(retVal.toString()) : '';
          }).join(",");
        }).join("\n");
        header = header.replaceAll("\n,", "\n");
      } finally {
        this.$emit('updateLoading', false);
      }

      const data = header + body;
      const bomFormatData = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
      const blob = new Blob([bomFormatData, data], { type: 'text/csv;charset=utf-8' });
      const link = window.document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.style.display = 'none';
      link.click();
      link.remove();
    },

    // テストデータを生成して返す
    getTestData: function () {
      return this.currentFFDContents;
    },

    // テーブルページの切り替え
    // switchTablePage: function (page) {
    // 	this.$refs.ffd_tbl.scrollToTop();
    //   this.currentPage = page;
    //   this.ffdTableItems = this.filterPerPageSize();
    // },

    // 取得できている FFD 情報全体から、現在のページ表示するものだけをフィルタ
    // filterPerPageSize: function () {
    //   const ret = this.ffdListBuff.filter((row, index) => {
    //     const start = (this.currentPage - 1) * this.maxItemsPerPage;
    //     const end = this.currentPage * this.maxItemsPerPage;
    //     return index >= start && index < end;
    //   });
    //   return ret;
    // },
  },

  computed: {
    ...mapState({
      cachedDetails: state => state.cache.projectDetails,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      isTestMode: state => state.netAppConnector.isTestMode,
    }),
    /** VIN */
    vin() {
      if (this.dataPlayback) {
        // データ再生の場合cacheを参照
        return this.cachedDetails.information.vin;
      } else if (this.isObd && !this.$route.path.includes('menu')) {
        // OBDかつStart画面から実行された場合、VIN取得していないため空文字
        return '';
      } else {
        return this.vehicleInfo?.vehicle?.vin?.vin || '';
      }
    },
    /** 実行画面 */
    operationScreen() {
      return diagnoseResource.operationFrom(this.$router.currentRoute.value.name);
    }
  },

  created() {
    // noop
  },

  mounted() {
    // FFD グループの選択オプションを生成
    if (this.isObd) {
      this.makeObdFFDGroupOptions();
      this.updateObdFFDTable(this.selectedFFDGroup);
    } else {
      this.makeFFDGroupOptions();
      this.updateFFDTable(this.selectedFFDGroup);
    }
  },
};